export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 订单管理-线上签约
    getOrderContractList: function getOrderContractList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/order/getContractList",
        method: "get",
        params: data
      });
    },
    // 国内签约
    getInternalOrderList: function getInternalOrderList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/getGn",
        method: "get",
        params: data
      });
    },
    // 跨境签约
    getCrossBorderOrderList: function getCrossBorderOrderList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/getKj",
        method: "get",
        params: data
      });
    },
    // 房源认证
    getHousingCertificationOrderList: function getHousingCertificationOrderList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/getRzf",
        method: "get",
        params: data
      });
    },
    // 房源推广
    getHousingPromotionOrderList: function getHousingPromotionOrderList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/getTgf",
        method: "get",
        params: data
      });
    },
    // 短信极速通知
    getSmsOrderList: function getSmsOrderList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/getDxjstz",
        method: "get",
        params: data
      });
    },
    // 实名认证
    getRealNameOrderList: function getRealNameOrderList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/getHouseAuth",
        method: "get",
        params: data
      });
    },
    getAuthOrderList: function getAuthOrderList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "admin/order/getAuthOrder",
        method: "get",
        params: data
      });
    },
    // 门票
    getTicketOrderList: function getTicketOrderList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/getMp",
        method: "get",
        params: data
      });
    },
    // 退款
    getRefundOrderList: function getRefundOrderList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order_refund/get",
        method: "get",
        params: data
      });
    },
    // 品牌季度
    getVipOrderList: function getVipOrderList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/getVipList",
        method: "get",
        params: data
      });
    },
    // 新增品牌季度订单
    addVipOrder: function addVipOrder() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/addVip",
        method: "post",
        data: data
      });
    },
    // 更新品牌季度订单
    updateVipOrder: function updateVipOrder() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/updateVip",
        method: "post",
        data: data
      });
    },
    // 删除品牌季度订单
    deleteVipOrder: function deleteVipOrder() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/order/deleteVip",
        method: "post",
        data: data
      });
    },
    // 活动退款接口
    activityOrderRefund: function activityOrderRefund() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/activity/order/refund",
        method: "post",
        data: data
      });
    }
  };
});